import React from 'react';
import { Dropdown, IDropdownOption, mergeStyleSets } from '@fluentui/react';
import { Funnel, X } from '@phosphor-icons/react';
import type { DashboardFilter } from '../../types/dashboard.types';

interface Props {
  filters: DashboardFilter[];
  onFilterChange: (filterId: string, value: string) => void;
  onRemoveFilter: (filterId: string) => void;
}

const s = mergeStyleSets({
  bar: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 20px',
    background: '#FFFFFF',
    borderBottom: '1px solid #E1E1E1',
    flexWrap: 'wrap' as const,
    flexShrink: 0,
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: '#747474',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap' as const,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  filterItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  removeBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#A0A0A0',
    padding: 2,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.12s',
    selectors: {
      ':hover': { color: '#D13438' },
    },
  },
});

export default function DashboardFilterBar({ filters, onFilterChange, onRemoveFilter }: Props) {
  if (filters.length === 0) return null;

  return (
    <div className={s.bar}>
      <span className={s.label}>
        <Funnel size={12} weight="regular" />
        Filters
      </span>
      {filters.map((filter) => {
        const options: IDropdownOption[] = [
          { key: '', text: `All ${filter.label}` },
          ...filter.values.map((v) => ({ key: v, text: v })),
        ];
        return (
          <div key={filter.id} className={s.filterItem}>
            <Dropdown
              selectedKey={filter.selectedValue || ''}
              options={options}
              onChange={(_, opt) => onFilterChange(filter.id, (opt?.key as string) || '')}
              styles={{
                dropdown: { minWidth: 160, border: '1px solid #E1E1E1', borderRadius: 4 },
                title: { fontSize: 12, fontWeight: 500, color: '#232323', borderRadius: 4 },
              }}
              placeholder={filter.label}
            />
            <button className={s.removeBtn} onClick={() => onRemoveFilter(filter.id)} title="Remove filter">
              <X size={10} weight="regular" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
